export default "__VITE_ASSET__BwwKwvTr__"